module.exports = __webpack_public_path__ + "img/project-mechanical.bec92054.svg";